var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HomeHero',{attrs:{"heroImg":_vm.heroImg,"title":_vm.title,"paragraph":_vm.desc}}),_vm._v(" "),_c('BrandsMatter'),_vm._v(" "),_c('PIPLife')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }